import { render, staticRenderFns } from "./ContentResourceCard.vue?vue&type=template&id=e089eb0a&"
import script from "./ContentResourceCard.vue?vue&type=script&lang=ts&"
export * from "./ContentResourceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports